

// src/Components/Resident/ProfileOverview.jsx
import React from "react";
import { Card, Row, Col, Badge, ListGroup } from "react-bootstrap";
import { useResidentProfile } from "../hooks/useResidentProfile";

export default function ProfilePage() {
  const {
    profileName, email, mobile, address, unit, family, computeAgeFromDOB,
  } = useResidentProfile();

  const initials = (profileName || email || "R")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <>
      {/* Header: avatar + primary info */}
      <Card className="mb-3">
        <Card.Body>
          <Row className="g-3 align-items-center">
            <Col md="auto">
              <div
                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                style={{ width: 64, height: 64, fontWeight: 600, fontSize: 20 }}
                aria-label="User avatar"
              >
                {initials}
              </div>
            </Col>
            <Col>
              <h5 className="mb-1">{profileName || "Resident"}</h5>
              {email && <div className="text-muted">{email}</div>}
              <div className="mt-2 d-flex flex-wrap gap-2">
                {mobile && <Badge bg="info">📞 {mobile}</Badge>}
                {unit?.blockName && <Badge bg="secondary">Block: {unit.blockName}</Badge>}
                {unit?.flatLabel && <Badge bg="secondary">Flat: {unit.flatLabel}</Badge>}
                {unit?.flatLabel?.bhkType && <Badge bg="secondary">Flat: {unit?.flatLabel?.bhkType}</Badge>}
              </div>
            </Col>

             <Col md={6}>
          <Card>
            <Card.Header>Address</Card.Header>
            <Card.Body>
              {address?.line1 || address?.line2 || address?.city ? (
                <address className="mb-0">
                  {address.line1 && <div>{address.line1}</div>}
                  {address.line2 && <div>{address.line2}</div>}
                  {(address.city || address.state || address.zip) && (
                    <div>{[address.city, address.state, address.zip].filter(Boolean).join(", ")}</div>
                  )}
                </address>
              ) : (
                <div className="text-muted">No address provided yet.</div>
              )}
            </Card.Body>
          </Card>
        </Col>


          </Row>
        </Card.Body>
      </Card>

      <Row className="g-3">
        {/* Address card */}
        {/* <Col md={6}>
          <Card>
            <Card.Header>Address</Card.Header>
            <Card.Body>
              {address?.line1 || address?.line2 || address?.city ? (
                <address className="mb-0">
                  {address.line1 && <div>{address.line1}</div>}
                  {address.line2 && <div>{address.line2}</div>}
                  {(address.city || address.state || address.zip) && (
                    <div>{[address.city, address.state, address.zip].filter(Boolean).join(", ")}</div>
                  )}
                </address>
              ) : (
                <div className="text-muted">No address provided yet.</div>
              )}
            </Card.Body>
          </Card>
        </Col> */}

        {/* Family list */}
        <Col md={6}>
          <Card>
            <Card.Header>Family</Card.Header>
            <ListGroup variant="flush">
              {Array.isArray(family) && family.length ? (
                family.map((m) => {
                  const computed = m.dob ? computeAgeFromDOB(m.dob) : undefined;
                  const displayAge = computed ?? m.age ?? "—";
                  return (
                    <ListGroup.Item key={m.id}>
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <div className="fw-semibold">{m.name}</div>
                          <div className="text-muted small">{m.relationship}</div>
                        </div>
                        <div className="text-end">
                          {m.dob && <div className="small">DOB: {m.dob}</div>}
                          <Badge bg="success">{displayAge} yrs</Badge>
                        </div>
                      </div>
                    </ListGroup.Item>
                  );
                })
              ) : (
                <ListGroup.Item className="text-muted">No family members added yet.</ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
}
